import {
  EventFeedFilterGroupKeys,
  EventFeedFiltersSchemas,
  ScreenerFilter,
} from '@toggle/toggle';

import {
  FilterGroups,
  FilterState,
} from '~/hooks/use-filter-actions/useFilterActions';

type EventFeedFilterGroup = EventFeedFiltersSchemas['groups'][number];

const defaultFilterState: FilterState = {
  activeFilterOptions: [],
  activeFilters: [],
  allFilters: [],
};

export const getGroupDisplayName = (
  group: { group: string; group_name?: string },
  groupKey?: string
): string =>
  group.group_name?.trim() ||
  (group.group
    ? group.group.charAt(0).toUpperCase() + group.group.slice(1)
    : groupKey ?? '');

export const mapEventFeedGroupToScreenerFilters = (
  group: EventFeedFilterGroup,
  groupDisplayName: string
): ScreenerFilter[] =>
  group.schemas.map(schema => {
    const filterName = (schema.name || schema.key).trim() || schema.key;
    return {
      key: schema.key,
      name: filterName,
      searchable: false,
      category: groupDisplayName,
      locked: schema.locked ?? true,
      visible: schema.visible ?? true,
      config: {
        name: filterName,
        multiselect: schema.config.multiselect,
        options: schema.config.options.map(opt => ({
          key: opt.key,
          name: (opt.name || opt.key).trim() || opt.key,
          description: '',
          value:
            opt.value &&
            typeof opt.value === 'object' &&
            !Array.isArray(opt.value)
              ? opt.value
              : {},
        })),
        ...(schema.config.custom && {
          custom: schema.config.custom,
        }),
      },
    };
  });

export const mapEventFeedFiltersSchemasToFilterGroups = (
  data: EventFeedFiltersSchemas,
  defaultFilterGroups: FilterGroups<EventFeedFilterGroupKeys>
): FilterGroups<EventFeedFilterGroupKeys> => {
  const filterGroups: FilterGroups<EventFeedFilterGroupKeys> = {
    ...defaultFilterGroups,
  };

  data.groups.forEach(group => {
    const groupKey = group.group;
    const groupDisplayName = getGroupDisplayName(group, String(groupKey));
    const groupSchemas = mapEventFeedGroupToScreenerFilters(
      group,
      groupDisplayName
    );

    filterGroups[groupKey] = {
      ...defaultFilterState,
      activeFilters: groupSchemas.filter(f => f.visible),
      allFilters: groupSchemas,
    };
  });

  return filterGroups;
};
